import {
  Header,
  Breadcrumb,
  Icon,
  Button,
} from 'semantic-ui-react';
import { Link, useNavigate } from 'react-router-dom';
import './Manuais.css';
import { voltarOuDashboard } from '../../utils/navegacao';

function Manuais() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="clearfix">
        <Header as="h3" style={{ float: 'left' }}>
          Manuais e procedimentos
        </Header>
        <div className="breadcrumb-com-voltar">
          <Button basic size="small" onClick={() => voltarOuDashboard(navigate)}>
            Voltar
          </Button>
          <Breadcrumb>
            <Breadcrumb.Section to="/" link as={Link}>
              Home
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Manuais</Breadcrumb.Section>
          </Breadcrumb>
        </div>
      </div>
      <div>
        <h4>Manuais dos sistemas</h4>

        <a href="/documentos/manual_pangeo.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Pangeo
        </a>
        <a href="/documentos/roteiro_comunica_empresas.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Comunica empresas
        </a>
        <a href="/documentos/roteiro_acervo.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Acervo Digital
        </a>
        <a href="/documentos/roteiro_consulta_arpan_web.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Arpan Web - Consulta de Pessoa Física
        </a>
        <h4>Manuais de procedimentos internos</h4>

        <a href="/documentos/acordo_coletivo_procedimento.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Acordo Coletivo
        </a>
        <a href="/documentos/delegado_sindical_procedimento.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Delegado Sindical
        </a>

        <h4>Manuais de outros documentos</h4>

        <a href="/documentos/delegado_sindical_regras.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Delegado Sindical - Palestra Dr Cesar
        </a>
        <a href="/documentos/negociacao_coletiva_reforma_trabalhista_palestra.pdf" target="_blank" className="manuais-link">
          <Icon name="file pdf outline" />
          <br />
          Negociação Coletiva - Palestra Dr Cesar
        </a>
      </div>
    </div>
  );
}

export default Manuais;
